import React from 'react';
import {StaticTextItem} from '../views/WeatherBroadcast/components/MapItems/MapItems';

export const weekdayLabel = (x, y, message) => {
  return (
    <StaticTextItem
      scale={0.5}
      position={{x: x, y: y}}
      backgroundColor='#868F9F'
      fontColor='#F5F5F5'
      size={{width: 320, height: 100}}
      message={message}
    />
  );
};

export const getWeekday = index => {
  const today = new Date();
  const weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  return weekdays[(today.getDay() + index) % weekdays.length];
};

export const createBackgroundElements = map => {
  if (map.id === 'prognose') {
    return (
      <>
        {weekdayLabel(858, 210, getWeekday(1))}
        {weekdayLabel(1214, 210, getWeekday(2))}
        {weekdayLabel(1570, 210, getWeekday(3))}
      </>
    );
  }
};
